import { render } from "./Packings.vue?vue&type=template&id=1e453f1d"
import script from "./Packings.vue?vue&type=script&lang=js"
export * from "./Packings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__